import Vue from 'vue'
import Router from 'vue-router'

import HelloWorld from '@/components/HelloWorld'
import PannelContent from '@/components/PannelContent.vue'
import PannelHome from '@/components/PannelHome.vue'
import PannelMessage from '@/components/PannelMessage.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect:'/home'
    },
    {
      path: '/home',
      name: '首页',
      component: PannelHome
    },
    
    {
      path: '/soft',
      name: '软件详情',
      component: PannelContent
    },
    // {
    //   path: '/soft/:id',
    //   name: '软件详情',
    //   component: PannelContent
    // },

    {
      path: '/message',
      name: '留言',
      component: PannelMessage
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js